import React from 'react';

import {
    Chart as ChartJS,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    CategoryScale,
  } from 'chart.js';
import { Line } from 'react-chartjs-2';
import annotationPlugin from 'chartjs-plugin-annotation';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    LinearScale, 
    PointElement, 
    LineElement, 
    Tooltip, 
    Legend, 
    CategoryScale, 
    annotationPlugin, 
    ChartDataLabels
  ); //ahhh the long lines at the registry. May it be school or a government facility


function LineChart({ dataset}){

    // const testPoints = [33, 53, 85, 41, 44, 39]; //y-axis
    // const labels = ['1/1/2022', '2/1/2022', '3/1/2022', '4/1/2022', '5/23/2022', '6/1/2022']; //x-axis
    const {minNormData, maxNormData, dataPoints} = dataset; 
    const labels = dataPoints.map( (item)=>{
        return item.x;
    });

    const yData = dataPoints.map((item)=>{
        return item.y;
    });

    console.log('dataset =>', dataset);
    console.log('minNormLine =>', minNormData);
    console.log('labels ', labels);
    console.log('yData', yData);


    const data = {
      labels: labels,
      datasets: [{
          label: "First dataset",
          data: yData,
          backgroundColor: "rgba(75,192,192,0.2)",
          borderColor: "rgba(75,192,192,1)",
          datalabels: {
            align: 'start',
            anchor: 'start',
          }
        },        
      ]
    };

    const minLine = (()=>{
        if(minNormData){
            return {
                type:'line',
                yMin: minNormData,
                yMax: minNormData,
                borderColor: "#E83845",
                borderWidth: 2
            }
        }
    })();

    const maxLine = (()=>{
        if(maxNormData){
            return {
                type:'line',
                yMin: maxNormData,
                yMax: maxNormData,
                borderColor: "#E83845",
                borderWidth: 2
              }
        }
    })();

      const options = {
        // parsing: false,
        scales:{
          y:{
            title: {display: true, text: "Y in units whatever"}
          },
          x:{
            adapter:{

            },
            title:{display: true, text:"Months in Whatever year"}
          }
        },
        responsive: true,
        plugins: {
            datalabels: {
                backgroundColor: function(context) {         
                    return context.dataset.backgroundColor;
                },
                borderRadius: 4,
                color: 'white',
                font: {
                weight: 'bold'
                },
                formatter: Math.round,
                padding: 6
            },
          annotation:{
            annotations:{
              minLine:minLine,
              maxLine:maxLine,
            }
          },
          tooltip:{
            // callbacks:{
            //   label: function(context){
            //     let label = context.dataset.label;                
            //     if(context.raw > 73.5){
            //       label = "HAHAHA YOU'RE FUCKED NOW!!!!!";
            //     }else if (context.raw < 40){
            //       label = "THAT'S BAD. You're doing well :D";
            //     }
            //     else{
            //       label = context.dataset.raw;
            //     }
            //     return label;
            //   },
            // }
          },
        },
      };

    return(
        <>
        <Line data={data} options={options} />
        </>
    );
};

export default LineChart;